import { GeosetsIndexPage, GeofencesRoute } from './-components';
import { createFileRoute, useRouter } from '@tanstack/react-router';

function GeosetsIndexRoute() {
  const router = useRouter();

  return (
    <GeofencesRoute
      permission="journeys/geofences/view"
      redirectTo={(params) =>
        router.buildLocation({
          to: '/workspaces/$workspaceId/journeys',
          params: { workspaceId: params.workspaceId },
        }).href
      }
    >
      <GeosetsIndexPage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geosets/')({
  component: GeosetsIndexRoute,
});
